<template>
    <div class="ticker">
        <!-- <div class="ticker-img"> 
            <img src="../../../assets/images/logo/icone-safras.svg">
        </div> -->
        <div class="ticker-card">
            <!-- <new-marquee-component></new-marquee-component> -->
            <new-marquee-component ref="marquee-component" v-if="newsTickerData.length > 0">
                <div class="ticker-card-item"
                    v-for="(item, index) in newsTickerData"
                    :key="index" 
                    @click.stop="openDetail(item)" 
                    :class="{'ticker-card-item-selected': isSelected(item)}"
                >
                    <informative-preview-data
                        v-if="isDesktop"
                        :data="item" 
                        :isDesktop="isDesktop" 
                        :isAuthenticated="isAuthenticated"
                        :iconReferencePreview="false"
                        :isMarqueePreview="true"
                        positionPreview="bottom"
                        @open-detail="openDetail(item)"
                    ></informative-preview-data>
                    <div class="ticker-card-item-thumb">
                        <img :src="item.thumb.image_path">
                    </div>
                    <div class="ticker-card-item-content">
                        <div class="ticker-card-item-hat">
                            <h6>{{ hat(item) }}</h6>
                            <!-- <div v-if="isImportant(item)">
                                <span> {{ $t('BADGES').Important }}</span>
                            </div> -->
                        </div>
                        <p class="ticker-card-item-title">{{ `${item.content.title.data}` }}</p>
                        <div class="ticker-card-item-time">
                            <!-- <span class="important-list-chip mr-1" v-if="isImportant"></span> -->
                            <div v-if="isImportant(item)">
                                <span> {{ $t('BADGES').Important }}</span>
                            </div>
                            <h6>{{ `${getHourTicker(item.dt_publish)}` }}</h6>
                        </div>
                        <!-- <p class="ticker-card-item-text" v-if="item.content.abstract.data">{{ `${item.content.abstract.data}` }}</p>
                        <p class="ticker-card-item-text" v-if="!item.content.abstract.data">{{ integerTicker(item.content.text.data) }}</p> -->
                    </div>
                    <!-- <div class="ticker-card-item-time">
                        <span>{{ `${getHourTicker(item.dt_publish)}` }}</span>
                    </div> -->
                </div>
            </new-marquee-component> 
        </div>
        <div class="ticker-options cursor-pointer">
            <vs-dropdown vs-trigger-click>
                <span>•••</span>
                <vs-dropdown-menu class="menu-ticker-options">
                    <!-- <vs-dropdown-item>
                        {{ $t('TICKER').View }}
                    </vs-dropdown-item>
                    <vs-divider></vs-divider> -->
                    <!-- Pedido para retirar as opções de filtro no jira PS-1267 -->
                    <!-- <vs-dropdown-item @click.stop="$emit('tickerFilterImportantSelected')">
                        {{ $t('TICKER').Important }} 
                        <feather-icon icon="CheckIcon" v-if="viewImportantTickers" class="ticker-menu-icon"></feather-icon>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="$emit('tickerFilterHighlightsSelected')">
                        {{ $t('TICKER').Highlights }} 
                        <feather-icon icon="CheckIcon" v-if="viewHighlightsTickers" class="ticker-menu-icon"></feather-icon>
                    </vs-dropdown-item>
                    <vs-divider></vs-divider> -->
                    <vs-dropdown-item @click="$emit('tickerViewOnPageTop')" v-if="!tickerViewAtTheTop">
                        {{ $t('TICKER').View_At_Top }} 
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="$emit('tickerViewOnPageTop')" v-if="tickerViewAtTheTop">
                        {{ $t('TICKER').View_In_Footer }} 
                    </vs-dropdown-item>
                    <vs-divider></vs-divider>
                    <vs-dropdown-item @click="changeDisplayTicker">
                        {{ $t("NAVBAR_DROPDOWN_MENU").Hide_Ticker }} 
                    </vs-dropdown-item>
                    <vs-divider></vs-divider>
                    <vs-dropdown-item class="ticker-refresh" @click="refreshTicker()">
                        <feather-icon icon="RefreshCwIcon" class="ticker-refresh-icon"></feather-icon>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <!-- <b-dropdown 
                size="lg"  
                variant="link" 
                toggle-class="text-decoration-none" 
                no-caret 
                dropright
            >
                <template #button-content>
                    <span>•••</span>
                </template>
                <b-dropdown-header> 
                    {{ $t('TICKER').View }}
                </b-dropdown-header>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click.stop="$emit('tickerFilterImportantSelected')">
                    {{ $t('TICKER').Important }} 
                    <feather-icon icon="CheckIcon" v-if="viewImportantTickers" class="ticker-menu-icon"></feather-icon>
                </b-dropdown-item>
                <b-dropdown-item @click.stop="$emit('tickerFilterHighlightsSelected')">
                    {{ $t('TICKER').Highlights }} 
                    <feather-icon icon="CheckIcon" v-if="viewHighlightsTickers" class="ticker-menu-icon"></feather-icon>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click.stop="$emit('tickerViewOnPageTop')" v-if="!tickerViewAtTheTop">
                    {{ $t('TICKER').View_At_Top }} 
                </b-dropdown-item>
                <b-dropdown-item @click.stop="$emit('tickerViewOnPageTop')" v-if="tickerViewAtTheTop">
                    {{ $t('TICKER').View_In_Footer }} 
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item class="ticker-refresh" @click="refreshTicker()"><feather-icon icon="RefreshCwIcon" class="ticker-refresh-icon"></feather-icon></b-dropdown-item>
            </b-dropdown>           -->
        </div>
    </div>
</template>




<script>

import AppConstants from '../../../appConstants';
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import FeatherIcon from '../../../components/FeatherIcon.vue';
import InformativePreviewData from './InformativePreviewData.vue';
import MarqueeComponent from '../widgets/marquee/MarqueeComponent.vue'
import NewMarqueeComponent from '../widgets/marquee/NewMarqueeComponent.vue'
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';

export default {

    watch: {

    },
    props: {
        newsTickerData: {
            type: Array,
            required: true,
        },
        isDesktop: {
            type: Boolean,
            required: true,
        },
        isAuthenticated: {
            require: true
        },
    },
    data() {
            return {
                // animationSpeed: 20,
                selectedTicker: false,
                selectedItem: null
        }
    },
    computed: {
        canDisplayTicker: {
            get() {
                return this.$store.state.canDisplayTicker;
            },
            set(val) {
                this.$store.dispatch('canDisplayTicker', val);
                this.$forceUpdate();
            }
        },
        tickerViewAtTheTop() {
            return this.$store.state.tickerViewAtTheTop;
        },
        viewImportantTickers() {
            return this.$store.state.viewImportantTickers;
        },
        viewHighlightsTickers() {
            return this.$store.state.viewHighlightsTickers;
        },
        // isDarkTheme() {
        //     let theme = localStorageHelper.getTheme();
        //     if (theme === AppConstants.THEME.DARK) {
        //         return true;
        //     }
        //     return false;
        // },
    },
    methods: {
        formatFullDate(val, obj) {
            return convertDatetimeHelper.formatFullDate(val, obj);
        },
        formatDate(val, obj) {
            return convertDatetimeHelper.formatDate(val, obj);
        },
        changeDisplayTicker() {
            this.canDisplayTicker=!this.canDisplayTicker;
        },
        integerTicker(item) {
            const regex = /[^,]+, \d+ de \w+ de \d+\s*-[\s\n]*\s*(.*)/ms;
            if (item) {
                const integer = regex.exec(item)
                if (integer && integer != null && integer[1] ) {
                    return integer[1];
                }
                return
            }
            return
        },
        refreshTicker() {
            this.selectedTicker = false;
            this.$emit("refreshTicker");
        },
        hat(item) {
            if (item) {
                if (item.hat[0]) {
                    return item.hat[0].name.toUpperCase();
                }
            }
            return "";
        },  
        openDetail(selectedItem) {
            this.selectedItem = selectedItem;
            this.$emit("openDetail", selectedItem);
        },
        isSelected(item) {
            return this.selectedItem === item;
        },
        getHourTicker(dt) {
            return convertDatetimeHelper.getTickerDate(dt);
        },
        isImportant(item) {
            if (item.importance ==  AppConstants.NEWS_IMPORTANCE.IMPORTANT) {
                return true
            }
            return false;
        },
        isItemNews(item) {
            if (item.newsContent[0]) {
                if (item.newsContent[0].code == CONTENT.NEWS) {
                return true;
                }
            }
            return false;
        },
    },
    components: {
        BDropdown,
        BDropdownItem,
        FeatherIcon,
        InformativePreviewData,
        MarqueeComponent,
        NewMarqueeComponent
    }

}

</script>

